import { FIRESTORE_HOST } from 'features/firebase/firebaseConfig';
import { HEALTH_ENDPOINT } from 'features/network/fetchNetworkProbe';
import { isIntentionalNavigation } from 'shared/utils/intentionalNavigationGuard';
import { isPageLeaving } from 'shared/utils/pageLeaveSignal';
import type { LogsEvent, LogsEventDomainContext } from '@datadog/browser-logs';

const FIRESTORE_CHANNEL_PATH =
  /^\/google\.firestore\.v1\.Firestore\/(Listen|Write)\/channel$/;

const parseUrl = (url: string): URL | null => {
  try {
    return new URL(url);
  } catch {
    return null;
  }
};

const isNetworkNoise = (
  event: LogsEvent,
  context: LogsEventDomainContext
): boolean => {
  if (context !== undefined && 'isAborted' in context && context.isAborted) {
    return true;
  }

  if (event.http?.status_code !== 0) {
    return false;
  }

  if (isIntentionalNavigation() || isPageLeaving()) {
    return true;
  }

  const url = parseUrl(event.http.url);

  if (url === null) {
    return false;
  }

  if (
    url.origin === window.location.origin &&
    url.pathname === HEALTH_ENDPOINT
  ) {
    return true;
  }

  return (
    url.hostname === FIRESTORE_HOST && FIRESTORE_CHANNEL_PATH.test(url.pathname)
  );
};

export const shouldSendLog = (
  event: LogsEvent,
  context: LogsEventDomainContext
): boolean => {
  if (event.status === 'debug') {
    return false;
  }

  return !(event.origin === 'network' && isNetworkNoise(event, context));
};
